enum UtmContents {
    bonus_share = 'bonus_share'
}

export { UtmContents }